import { useEffect } from 'react';
import qs from 'qs';
import { propOr } from 'ramda';

import { getSource } from '../../../../../core/libs/browser/browser';
import { sendEvent } from '../../../../../core/services/tracking';

function useCards(posData, adData, extrasData, loading) {
  useEffect(() => { loading.stop() }, []);

  function createBuyUrl(productCode) {
    const { REACT_APP_OCTOPOS_HOST } = process.env;
    const {
      legacyAdId,
      adId,
    } = adData;
    const {
      name: pointOfSale, referral, coupon, funnelId,
    } = posData;
    const { tag_id: tagId, product_name: productName } = propOr({}, 'rtb', extrasData);
    const utms = (document.location.search.match(/(utm_[\w]+=[\w_-]*)/g) || []).join('&');

    const params = {
      adId,
      productCode,
      pointOfSale,
      platform: getSource(),
      referral,
      coupon,
      rtb_tag_id: tagId,
      rtb_product_name: productName,
      funnelId,
      utms,
    };

    sendEvent({
      event_type: 'click',
      object_detail: 'subscription_buy',
      data: {
        funnel_id: funnelId,
        ad_id: legacyAdId,
        product: productCode,
        point_of_sale: 'cars-subscription-bundle',
        referral,
      },
    });

    return `${REACT_APP_OCTOPOS_HOST}/api/v1/buy?${qs.stringify(params)}`;
  }

  function onClickBuyButton(productCode) {
    loading.start();

    const url = createBuyUrl(productCode);

    window.open(url, '_self');
  }

  return {
    onClickBuyButton,
  };
}

export default useCards;
